/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ornate_Proud_Fish_CheerInputs */

const fr_ornate_proud_fish_cheer = /** @type {(inputs: Ornate_Proud_Fish_CheerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer la catégorie`)
};

/**

* @param {Ornate_Proud_Fish_CheerInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const ornate_proud_fish_cheer = /** @type {((inputs?: Ornate_Proud_Fish_CheerInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ornate_Proud_Fish_CheerInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_ornate_proud_fish_cheer(inputs)
});